const MiniQ2PrevM = ({item, t}) => {
    return (
        <>
            {
                item.values.dist_p0 > 0 &&
                <>
                    <div className="h6 preview-input text-center mt-3">P0</div>
                    <div className="preview-item">
                        <label>{t("distance")} P0:</label>
                        <div className="preview-input d-inline-block">{item.values.dist_p0}</div>
                    </div>
                    <div className="preview-item">
                        <div className="row">
                            <div className="col-6">
                                <label>{t("pulses")} P0:</label>
                                <div className="preview-input d-inline-block">{item.values.pulsos_p0}</div>
                            </div>
                            <div className="col-6">
                                <label>{t("intervals")} P0:</label>
                                <div className="preview-input d-inline-block">{item.values.intpuls_p0}</div>
                            </div>
                            <div className="col-6">
                                <label>{t("power")} TX P0:</label>
                                <div className="preview-input d-inline-block">{item.values.pot_tx_p0}</div>
                            </div>
                            <div className="col-6">
                                <label>{t("threshold")} RX P0:</label>
                                <div className="preview-input d-inline-block">{item.values.pot_rx_p0}</div>
                            </div>
                        </div>
                    </div>
                </>
            }
            {
                item.values.dist_p1 > 0 &&
                <>
                    <div className="h6 preview-input text-center mt-3">P1</div>
                    <div className="preview-item">
                        <label>{t("distance")} P1:</label>
                        <div className="preview-input d-inline-block">{item.values.dist_p1}</div>
                    </div>
                    <div className="preview-item">
                        <div className="row">
                            <div className="col-6">
                                <label>{t("pulses")} P1:</label>
                                <div className="preview-input d-inline-block">{item.values.pulsos_p1}</div>
                            </div>
                            <div className="col-6">
                                <label>{t("intervals")} P1:</label>
                                <div className="preview-input d-inline-block">{item.values.intpuls_p1}</div>
                            </div>
                            <div className="col-6">
                                <label>{t("power")} TX P1:</label>
                                <div className="preview-input d-inline-block">{item.values.pot_tx_p1}</div>
                            </div>
                            <div className="col-6">
                                <label>{t("threshold")} RX P1:</label>
                                <div className="preview-input d-inline-block">{item.values.pot_rx_p1}</div>
                            </div>
                        </div>
                    </div>
                </>
            }
            {
                item.values.dist_p2 > 0 &&
                <>
                    <div className="h6 preview-input text-center mt-3">P2</div>
                    <div className="preview-item">
                        <label>{t("distance")} P2:</label>
                        <div className="preview-input d-inline-block">{item.values.dist_p2}</div>
                    </div>
                    <div className="preview-item">
                        <div className="row">
                            <div className="col-6">
                                <label>{t("pulses")} P2:</label>
                                <div className="preview-input d-inline-block">{item.values.pulsos_p2}</div>
                            </div>
                            <div className="col-6">
                                <label>{t("intervals")} P2:</label>
                                <div className="preview-input d-inline-block">{item.values.intpuls_p2}</div>
                            </div>
                            <div className="col-6">
                                <label>{t("power")} TX P2:</label>
                                <div className="preview-input d-inline-block">{item.values.pot_tx_p2}</div>
                            </div>
                            <div className="col-6">
                                <label>{t("threshold")} RX P2:</label>
                                <div className="preview-input d-inline-block">{item.values.pot_rx_p2}</div>
                            </div>
                        </div>
                    </div>
                </>
            }
            {
                item.values.dist_p3 > 0 &&
                <>
                    <div className="h6 preview-input text-center mt-3">P3</div>
                    <div className="preview-item">
                        <label>{t("distance")} P3:</label>
                        <div className="preview-input d-inline-block">{item.values.dist_p3}</div>
                    </div>
                    <div className="preview-item">
                        <div className="row">
                            <div className="col-6">
                                <label>{t("pulses")} P3:</label>
                                <div className="preview-input d-inline-block">{item.values.pulsos_p3}</div>
                            </div>
                            <div className="col-6">
                                <label>{t("intervals")} P3:</label>
                                <div className="preview-input d-inline-block">{item.values.intpuls_p3}</div>
                            </div>
                            <div className="col-6">
                                <label>{t("power")} TX P3:</label>
                                <div className="preview-input d-inline-block">{item.values.pot_tx_p3}</div>
                            </div>
                            <div className="col-6">
                                <label>{t("threshold")} RX P3:</label>
                                <div className="preview-input d-inline-block">{item.values.pot_rx_p3}</div>
                            </div>
                        </div>
                    </div>
                </>
            }
        </>
    )
}
export default MiniQ2PrevM